"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPlan = exports.isPlan = void 0;
const __1 = require("..");
function isPlan(object) {
    return checkPlan(object).fulfilled;
}
exports.isPlan = isPlan;
function checkPlan(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, __1.check)(object, (0, __1.hasString)("stripeId"), (0, __1.hasString)("name"), (0, __1.hasNumber)("grade").integer(), (0, __1.hasChoice)("paymentInterval", ["MONTHLY", "YEARLY"]), (0, __1.hasMap)("costPerUser", (0, __1.isNumber)()), (0, __1.hasNumber)("validFrom").integer().optional()).withOptions(options).explain();
}
exports.checkPlan = checkPlan;
//# sourceMappingURL=Plan.js.map